import React from 'react';
import { Link } from 'react-router-dom';
import { Product } from '../../types/store';
interface ProductCardProps {
  product: Product;
  storeSlug: string;
}
export function ProductCard({
  product,
  storeSlug
}: ProductCardProps) {
  const minPrice = Math.min(...product.variants.map(v => v.price));
  const hasPersonalization = product.personalizationFields.length > 0;
  return <Link to={`/store/${storeSlug}/products/${product.id}`} className="group bg-white rounded-lg border border-gray-200 overflow-hidden hover:shadow-lg transition-shadow" data-id="element-214">
      <div className="aspect-square bg-gray-100 flex items-center justify-center" data-id="element-215">
        <div className="text-gray-400 text-sm" data-id="element-216">Product Image</div>
      </div>
      <div className="p-4" data-id="element-217">
        <h3 className="font-medium text-gray-900 group-hover:text-red-600 transition-colors" data-id="element-218">
          {product.name}
        </h3>
        <p className="text-sm text-gray-500 mt-1 line-clamp-2" data-id="element-219">
          {product.description}
        </p>
        <div className="mt-3 flex items-center justify-between" data-id="element-220">
          <span className="text-lg font-bold text-gray-900" data-id="element-221">
            ${minPrice.toFixed(2)}
            {product.variants.length > 1 && <span className="text-sm font-normal text-gray-500" data-id="element-222"> & up</span>}
          </span>
          {hasPersonalization && <span className="text-xs bg-blue-100 text-blue-700 px-2 py-1 rounded-full" data-id="element-223">
              Customizable
            </span>}
        </div>
      </div>
    </Link>;
}